var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "navbar"
  }, [_c("transition", {
    attrs: {
      name: "slide-fade"
    }
  }, [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showHead,
      expression: "showHead"
    }],
    ref: "header",
    staticClass: "topBar",
    style: {
      backgroundColor: _vm.formData.bgColor,
      color: _vm.formData.textColor + "  !important"
    }
  }, [_vm.formData.lang ? _c("div", {
    staticClass: "left",
    style: {
      color: _vm.formData.textColor + "  !important"
    },
    on: {
      click: function click($event) {
        _vm.LanguageShow = !_vm.LanguageShow;
      }
    }
  }, [_c("svg", {
    staticClass: "icon universe",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c("use", {
    attrs: {
      "xlink:href": "#icon-a-32-Universe"
    }
  })]), _c("span", [_vm._v(_vm._s(_vm.languageName))]), _c("svg", {
    staticClass: "icon down",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c("use", {
    attrs: {
      "xlink:href": "#icon-a-32-ArrowDown"
    }
  })])]) : _vm._e(), _c("div", {
    staticClass: "right",
    style: {
      color: _vm.formData.textColor + "  !important"
    },
    on: {
      click: _vm.toSearch
    }
  }, [_vm._v(" " + _vm._s(_vm.placeholder) + " "), _c("svg", {
    staticClass: "icon seek",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c("use", {
    attrs: {
      "xlink:href": "#icon-a-32-Search"
    }
  })])]), _vm.LanguageShow && _vm.languages ? _c("div", {
    staticClass: "topLanguage"
  }, _vm._l(_vm.languages, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "LanguageItem",
      on: {
        click: function click($event) {
          return _vm.handleClick(item.langId, item.langTitle);
        }
      }
    }, [_vm._v(" " + _vm._s(item.langTitle) + " ")]);
  }), 0) : _vm._e()])])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };